var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.937,
    height: 99.937,
    viewBox: "0 0 99.937 99.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_452",
    x: 15.859,
    y: 63.435,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_453",
    x: 56.827,
    y: 7.929,
    width: 25.929,
    height: 25.929,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_454",
    x: 67.4,
    y: 15.859,
    width: 25.929,
    height: 25.929,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_455",
    x: 59.71,
    y: 7.206,
    width: 30.777,
    height: 35.325,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_456",
    x: 50.22,
    y: 47.576,
    width: 31.216,
    height: 47.074,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_457",
    x: 34.361,
    y: 63.435,
    width: 31.216,
    height: 31.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_458",
    x: 34.361,
    y: 47.576,
    width: 31.216,
    height: 31.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_459",
    x: 34.361,
    y: 31.718,
    width: 31.216,
    height: 31.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_460",
    x: 18.502,
    y: 31.718,
    width: 31.216,
    height: 31.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_461",
    x: 50.22,
    y: 31.718,
    width: 31.216,
    height: 31.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_462",
    x: 0,
    y: 0,
    width: 99.937,
    height: 99.937,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_463",
    x: 5.222,
    y: 60.728,
    width: 32.161,
    height: 32.161,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_340",
    "data-name": "Groupe 340",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_337",
    "data-name": "Groupe 337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_452-2",
    "data-name": "Trac\\xE9 452",
    d: "M6,179.07",
    transform: "translate(18.86 -109.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_453-2",
    "data-name": "Trac\\xE9 453",
    d: "M199.929-68.965a3.969,3.969,0,0,0-3.965-3.965A3.969,3.969,0,0,0,192-68.965,3.969,3.969,0,0,0,195.965-65a3.969,3.969,0,0,0,3.965-3.965Zm-5.286,0a1.322,1.322,0,0,1,1.322-1.322,1.322,1.322,0,0,1,1.322,1.322,1.322,1.322,0,0,1-1.322,1.322,1.322,1.322,0,0,1-1.322-1.322Zm0,0",
    transform: "translate(-126.17 86.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_454-2",
    "data-name": "Trac\\xE9 454",
    d: "M243.965-36.93A3.969,3.969,0,0,0,240-32.965,3.969,3.969,0,0,0,243.965-29a3.969,3.969,0,0,0,3.965-3.965,3.969,3.969,0,0,0-3.965-3.965Zm0,5.286a1.322,1.322,0,0,1-1.322-1.322,1.322,1.322,0,0,1,1.322-1.322,1.322,1.322,0,0,1,1.322,1.322,1.322,1.322,0,0,1-1.322,1.322Zm0,0",
    transform: "translate(-163.6 58.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_455-2",
    "data-name": "Trac\\xE9 455",
    d: "M205.086-60.357l10.578-15.858,2.2,1.467L207.285-58.89Zm0,0",
    transform: "translate(-136.38 89.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_456-2",
    "data-name": "Trac\\xE9 456",
    d: "M171.251,107.07h-5.286A3.969,3.969,0,0,0,162,111.035V132.18a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965V111.035a3.969,3.969,0,0,0-3.965-3.965Zm1.322,25.11a1.322,1.322,0,0,1-1.322,1.322h-5.286a1.322,1.322,0,0,1-1.322-1.322V111.035a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(-102.78 -53.49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_457-2",
    "data-name": "Trac\\xE9 457",
    d: "M99.251,179.07H93.965A3.969,3.969,0,0,0,90,183.035v5.286a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965v-5.286a3.969,3.969,0,0,0-3.965-3.965Zm1.322,9.251a1.322,1.322,0,0,1-1.322,1.322H93.965a1.322,1.322,0,0,1-1.322-1.322v-5.286a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(-46.64 -109.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_458-2",
    "data-name": "Trac\\xE9 458",
    d: "M99.251,107.07H93.965A3.969,3.969,0,0,0,90,111.035v5.286a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965v-5.286a3.969,3.969,0,0,0-3.965-3.965Zm1.322,9.251a1.322,1.322,0,0,1-1.322,1.322H93.965a1.322,1.322,0,0,1-1.322-1.322v-5.286a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(-46.64 -53.49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_459-2",
    "data-name": "Trac\\xE9 459",
    d: "M99.251,35.07H93.965A3.969,3.969,0,0,0,90,39.035v5.286a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965V39.035a3.969,3.969,0,0,0-3.965-3.965Zm1.322,9.251a1.322,1.322,0,0,1-1.322,1.322H93.965a1.322,1.322,0,0,1-1.322-1.322V39.035a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(-46.64 2.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_460)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_460-2",
    "data-name": "Trac\\xE9 460",
    d: "M27.251,35.07H21.965A3.969,3.969,0,0,0,18,39.035v5.286a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965V39.035a3.969,3.969,0,0,0-3.965-3.965Zm1.322,9.251a1.322,1.322,0,0,1-1.322,1.322H21.965a1.322,1.322,0,0,1-1.322-1.322V39.035a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(9.5 2.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_461-2",
    "data-name": "Trac\\xE9 461",
    d: "M162,39.035v5.286a3.969,3.969,0,0,0,3.965,3.965h5.286a3.969,3.969,0,0,0,3.965-3.965V39.035a3.969,3.969,0,0,0-3.965-3.965h-5.286A3.969,3.969,0,0,0,162,39.035Zm10.573,0v5.286a1.322,1.322,0,0,1-1.322,1.322h-5.286a1.322,1.322,0,0,1-1.322-1.322V39.035a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322Zm0,0",
    transform: "translate(-102.78 2.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_462-2",
    "data-name": "Trac\\xE9 462",
    d: "M15.937-93.071A15.876,15.876,0,0,0,.078-108.93H-46.176a6.615,6.615,0,0,0-6.608,6.608V-56A14.551,14.551,0,0,0-66-41.53,14.554,14.554,0,0,0-51.463-26.993H-3.886A6.615,6.615,0,0,0,2.721-33.6V-77.452a15.87,15.87,0,0,0,13.216-15.62ZM-63.357-41.53A11.907,11.907,0,0,1-51.463-53.424,11.907,11.907,0,0,1-39.569-41.53,11.907,11.907,0,0,1-51.463-29.636,11.907,11.907,0,0,1-63.357-41.53Zm18.5-12.933v-2.926a1.322,1.322,0,0,1,1.322-1.322h5.286a1.322,1.322,0,0,1,1.322,1.322V-52.1a1.322,1.322,0,0,1-1.322,1.322h-2.01a14.65,14.65,0,0,0-4.6-3.682ZM.078-33.6a3.969,3.969,0,0,1-3.965,3.965H-43.131A14.522,14.522,0,0,0-36.926-41.53a14.441,14.441,0,0,0-1.6-6.608h.283A3.969,3.969,0,0,0-34.282-52.1v-5.286a3.969,3.969,0,0,0-3.965-3.965h-5.286A3.969,3.969,0,0,0-47.5-57.389V-55.5a14.57,14.57,0,0,0-2.643-.5v-46.321a3.969,3.969,0,0,1,3.965-3.965H-8.669a16,16,0,0,0-3.04,2.643H-44.855A2.646,2.646,0,0,0-47.5-101v15.859A2.646,2.646,0,0,0-44.855-82.5h33.146A15.808,15.808,0,0,0,.078-77.212ZM-13.636-101a15.74,15.74,0,0,0-2.145,7.929,15.74,15.74,0,0,0,2.145,7.929H-44.855V-101ZM.078-79.856A13.23,13.23,0,0,1-13.137-93.071,13.23,13.23,0,0,1,.078-106.287,13.23,13.23,0,0,1,13.294-93.071,13.23,13.23,0,0,1,.078-79.856Zm0,0",
    transform: "translate(75 114.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_463-2",
    "data-name": "Trac\\xE9 463",
    d: "M-39.121,171.2a7.087,7.087,0,0,1,6.565-4.425,7.042,7.042,0,0,1,4.046,1.271.886.886,0,0,1,.22,1.233.885.885,0,0,1-1.232.218,5.287,5.287,0,0,0-3.034-.952,5.31,5.31,0,0,0-4.6,2.655h4.6a.885.885,0,0,1,.885.885.885.885,0,0,1-.885.885h-5.237a5.324,5.324,0,0,0-.073.885,5.324,5.324,0,0,0,.073.885h5.237a.885.885,0,0,1,.885.885.885.885,0,0,1-.885.885h-4.6a5.31,5.31,0,0,0,4.6,2.655,5.286,5.286,0,0,0,3.034-.952.885.885,0,0,1,1.232.219.886.886,0,0,1-.22,1.233,7.044,7.044,0,0,1-4.046,1.271,7.087,7.087,0,0,1-6.565-4.425h-2.285a.885.885,0,0,1-.885-.885.885.885,0,0,1,.885-.885h1.825a7.115,7.115,0,0,1-.055-.885,7.114,7.114,0,0,1,.055-.885h-1.825a.885.885,0,0,1-.885-.885.885.885,0,0,1,.885-.885Zm0,0",
    transform: "translate(56.51 -100.05)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator-icon.99e72099463c917d4f501a7c4961896b.svg";
export { ForwardRef as ReactComponent };